import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    MoveOrdersWidget: {
        background: '#f5f6fa',
        padding: '17px',
        '& .Btn--Primary': {
            "background": "#6E7187",
            "boxShadow": "0px 10px 30px rgba(0, 0, 0, 0.07), 0px 4px 18px rgba(249, 98, 83, 0.25)",
            "borderRadius": "8px",
            "fontWeight": "700",
            "fontSize": "12px",
            "lineHeight": "15px",
            "textAlign": "center",
            "textTransform": "uppercase",
            "color": "#FFFFFF",
            // boxShadow: 'none',
            border: 'none',
            padding: '16px',
            display: 'block',
            width: '100%'
        },
        '& .Btn--Secondary': {
            "background": "#e14954",
            "boxShadow": "0px 10px 30px rgba(0, 0, 0, 0.07), 0px 4px 18px rgba(249, 98, 83, 0.25)",
            "borderRadius": "8px",
            "fontWeight": "700",
            "fontSize": "12px",
            "lineHeight": "15px",
            "textAlign": "center",
            "textTransform": "uppercase",
            "color": "#FFFFFF",
            // boxShadow: 'none',
            border: 'none',
            padding: '16px',
            display: 'block',
            width: '100%'
        }
    },
    SmallTablePlaceholderWrapper: {
        marginBottom: '20px'
    },
    PayOrdersWidget__Title: {
        "fontStyle": "normal",
        "fontWeight": "700",
        "fontSize": "14px",
        "lineHeight": "17px",
        "textTransform": "uppercase",
        "color": "#271D1C",
        marginBottom: '12px',
        textAlign: 'center'
    },
    OrdersWrap: {
        "background": "rgba(251, 253, 245, 0.75)",
        "borderRadius": "8px",
        padding: '12px',
        marginBottom: '12px'
    }
}));
